import axios from "@/api/axios";

const getDocuments = () => {
  return axios.get(`files`);
};

const getNextFolderDocuments = (data) => {
  const folderName = encodeURIComponent(data.name || "");
  const currentPath = encodeURIComponent(data.currentPath || "");
  return axios.get(`next-folder?folderName=${folderName}&currentPath=${currentPath}`);
}
const downloadFile = (data) => {
  const fileName = encodeURIComponent(data.name || "");
  const currentPath = encodeURIComponent(data.currentPath || "");
  return axios.get(`download?fileName=${fileName}&currentPath=${currentPath}`, {
    responseType: "blob",
  })
}
export default {
  getDocuments,
  getNextFolderDocuments,
  downloadFile

};
